'use client'

import { cn } from '@/lib/utils'

// ReactBits StarBorder (free registry: reactbits.dev/r/StarBorder-JS-TW),
// adapted for Kingdom Kode. The traveling top/bottom edge-glow mechanic is the
// ReactBits original; the inner content box is parameterized (`innerClassName`)
// so callers can shape it — e.g. a gold pill (see StarBorderButton). Keyframes
// live in tailwind.css as --animate-star-movement-top/bottom; the glow speed
// is set inline via animationDuration. Reduced-motion hides the glows.
export function StarBorder({
  as: Component = 'div',
  className = '',
  innerClassName = '',
  color = 'white',
  speed = '6s',
  thickness = 1,
  glowOpacity = 0.7,
  children,
  style,
  ...rest
}) {
  return (
    <Component
      className={cn('relative inline-block overflow-hidden', className)}
      style={{ padding: `${thickness}px 0`, ...style }}
      {...rest}
    >
      <div
        className="animate-star-movement-bottom absolute right-[-250%] bottom-[-11px] z-0 h-1/2 w-[300%] rounded-full motion-reduce:hidden"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
          opacity: glowOpacity,
        }}
      />
      <div
        className="animate-star-movement-top absolute top-[-10px] left-[-250%] z-0 h-1/2 w-[300%] rounded-full motion-reduce:hidden"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
          opacity: glowOpacity,
        }}
      />
      <div className={cn('relative z-[1]', innerClassName)}>{children}</div>
    </Component>
  )
}
